import { useTranslation } from "react-i18next";
import { ArrowDown } from "@phosphor-icons/react";

const PILLS_KEYS = ["pill1", "pill2", "pill3"];

export const GestionHero = () => {
  const { t } = useTranslation();

  return (
    <section
      data-testid="gestion-hero"
      className="relative flex items-center justify-center min-h-screen pt-32 pb-24 overflow-hidden"
    >
      <div className="absolute inset-0 adonis-grid-bg [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_75%)]" />
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[520px] w-[820px] opacity-30 blur-3xl pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, #7B61FF 0%, transparent 60%), radial-gradient(circle at 30% 50%, #4DD0E1 0%, transparent 60%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-[1] text-slate-900">
          {t("gestion.hero.title_a")}
          <br />
          <span className="adonis-gradient-text">
            {t("gestion.hero.title_b")}
          </span>
        </h1>

        <p className="mt-10 mx-auto max-w-2xl text-lg leading-relaxed text-slate-600">
          {t("gestion.hero.subtitle")}
        </p>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
          {PILLS_KEYS.map((key) => (
            <span
              key={key}
              data-testid={`hero-pill-${key}`}
              className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/80 backdrop-blur-sm px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] text-slate-700 shadow-sm"
            >
              <span className="h-1.5 w-1.5 rounded-full adonis-gradient" />
              {t(`gestion.hero.${key}`)}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 text-slate-400">
        <ArrowDown
          size={16}
          weight="bold"
          className="animate-bounce [animation-duration:2s]"
        />
        <span className="text-[10px] font-bold uppercase tracking-[0.3em]">
          {t("gestion.hero.scroll")}
        </span>
      </div>
    </section>
  );
};

export default GestionHero;
